import { render, staticRenderFns } from "./search-suggestions-main-header.vue?vue&type=template&id=2af0a30a&scoped=true&"
import script from "./search-suggestions-main-header.vue?vue&type=script&lang=js&"
export * from "./search-suggestions-main-header.vue?vue&type=script&lang=js&"
import style0 from "./search-suggestions-main-header.vue?vue&type=style&index=0&id=2af0a30a&prod&lang=scss&"
import style1 from "./search-suggestions-main-header.vue?vue&type=style&index=1&id=2af0a30a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af0a30a",
  null
  
)

export default component.exports